import { Model } from '@vuex-orm/core'
import Journey from './Journey'
import Customer from './Customer'
export default class Booking extends Model {
  static entity = 'bookings'

  static fields() {
    return {
      ref: this.attr(''),
      id: this.increment(),
      source: this.attr([]),
      can_be_edited: this.attr(''),
      can_be_recurred: this.attr(''),
      can_be_duplicated: this.attr(''),
      data_source: this.attr(''),
      bespoke: this.boolean(false),
      customer: this.belongsTo(Customer, 'customer_id'),
      journeys: this.hasMany(Journey, 'booking_id'),
      status: this.attr(''),
    }
  }
}
